import { ContainerResponseDto, IssueResponseDto, IssueType, ObjectType } from '@planning/app/api'
import { EntityItem } from '@planning/rt-stores/base/EntityItem'
import { ContainerItemStore } from '@planning/rt-stores/container/ContainerItemStore'
import { IEntity } from '@planning/rt-stores/types'
import _ from 'lodash'
import { computed, makeObservable } from 'mobx'
import { IContainerJourneyItem } from './ContainerJourneyItem'
import { ContainerJourneyItemStore } from './ContainerJourneyItemStore'
import { IssueItemStore } from './IssueItemStore'

export interface IIssueItem extends IEntity<IssueResponseDto> {
  containerJourney: IContainerJourneyItem | undefined
  container: ContainerResponseDto | undefined
  issueTitle: string
  isValidContainerOrOrderIssue: boolean
  containsContainerNumber(containerNumber: string): boolean
}

export class IssueItem extends EntityItem<IssueResponseDto> implements IIssueItem {
  constructor(
    public issueItemStore: IssueItemStore,
    public containerJourneyItemStore: ContainerJourneyItemStore,
    public containerItemStore: ContainerItemStore,
    id: number,
    data: IssueResponseDto,
  ) {
    super(id, data)

    makeObservable(this, {
      containerJourney: computed,
      container: computed,
      issueTitle: computed,
      isValidContainerOrOrderIssue: computed,
    })
  }

  containsContainerNumber(containerNumber: string): boolean {
    return (
      !!this.containerJourney?.container?.data.number?.includes(containerNumber) ||
      !!this.container?.number?.includes(containerNumber)
    )
  }

  get isValidContainerOrOrderIssue(): boolean {
    return (
      (this.data.objectType === 'Container' && !!this.container) ||
      (this.data.objectType === 'Order' && !!this.containerJourney)
    )
  }

  get containerJourney() {
    switch (this.data.objectType) {
      case ObjectType.Order:
        return (
          this.containerJourneyItemStore.journeysByInboundOrderId[this.data.objectId] ??
          this.containerJourneyItemStore.journeysByOutboundOrderId[this.data.objectId]
        )
      case ObjectType.Container:
        return this.containerJourneyItemStore.journeysByContainerId[this.data.objectId]
      default:
        return undefined
    }
  }

  get container() {
    switch (this.data.objectType) {
      case ObjectType.Container:
        return _.values(this.containerItemStore.elements).find(
          container => container.id === this.data.objectId,
        )?.data
      default:
        return undefined
    }
  }

  get issueTitle() {
    if (
      this.data.issueType === IssueType.MissingCompany &&
      this.data.objectType === ObjectType.Order
    )
      return 'missingCustomer'

    if (
      this.data.issueType === IssueType.MissingCompany ||
      this.data.issueType === IssueType.UnknownCompany
    ) {
      return `${this.data.issueType}_${this.data.companyType}`
    }

    return this.data.issueType?.toString()
  }
}
